module.exports = __webpack_public_path__ + "static/js/2.4b32a5fe.chunk.worker.js"